import React, { useEffect, useState } from 'react'
import './BillingDetails.css'
import { Col, Row } from 'react-bootstrap'
import {
  deleteUserAddress,
  getUserAddress
} from '../../services/BillingService'
const BillingDetails = ({
  userAddress,
  formData,
  handleChange,
  addAddress,
  handleAddressSelection,
  setSelectedAddressIndex,
  selectedAddressIndex,
  addNewAddress,
  setAddNewAddress,

  errors,
  handleSaveAddress
}) => {
  return (
    <div className='bg_clr_light_yellow pb-lg-5 mt-4 position-relative'>
      <div className=''>
        <div className='d-flex flex-column-reverse'>
          <Row className='pb-4'>
            <h2 className='ff_heebo fw-bold fs_7xl clr_dark_blue_2'>Address</h2>
            <Col>
              {userAddress && userAddress.length === 0 ? (
                <div className='form-border p-4 rounded-2'>
                  {/* Form for adding new address */}
                  <div className='d-flex align-items-center justify-content-between gap-3'>
                    <div className='d-flex flex-column w-100'>
                      <input
                        className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                        type='text'
                        name='firstName'
                        placeholder='First Name'
                        value={formData.firstName}
                        onChange={e => handleChange(e)}
                      />
                      {errors?.firstName && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.firstName}
                        </p>
                      )}
                    </div>
                    <div className='d-flex flex-column w-100'>
                      <input
                        className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                        type='text'
                        name='lastName'
                        placeholder='Last Name'
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      {errors?.lastName && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.lastName}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                      type='text'
                      name='companyName'
                      placeholder='Company name ( optional )'
                      value={formData.companyName}
                      onChange={handleChange}
                    />
                    {errors?.companyName && (
                      <p className='text-danger fs_2xsm mt-1'>
                        {errors.companyName}
                      </p>
                    )}
                  </div>
                  <div className='d-flex align-items-center justify-content-between gap-3'>
                    <div className='d-flex flex-column w-100'>
                      <input
                        className='w-75 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                        type='text'
                        name='streetAddress'
                        placeholder='Street address'
                        value={formData.streetAddress}
                        onChange={handleChange}
                      />
                      {errors?.streetAddress && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.streetAddress}
                        </p>
                      )}
                    </div>
                    <div className='d-flex flex-column w-100'>
                      <input
                        className='w-25 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                        type='text'
                        name='state'
                        placeholder='State'
                        value={formData.state}
                        onChange={handleChange}
                      />
                      {errors?.state && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.state}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className='d-flex align-items-center justify-content-between gap-3'>
                    <div className='d-flex flex-column w-100'>
                      <input
                        className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                        type='text'
                        name='city'
                        placeholder='Town/City'
                        value={formData.city}
                        onChange={handleChange}
                      />
                      {errors?.city && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.city}
                        </p>
                      )}
                    </div>
                    <div className='d-flex flex-column w-100'>
                      <input
                        className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                        type='text'
                        name='pincode'
                        placeholder='Pin Code'
                        value={formData.pincode}
                        onChange={handleChange}
                      />
                      {errors?.pincode && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.pincode}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className='d-flex align-items-center justify-content-between gap-3 mt-3'>
                    <div className='d-flex flex-column w-100'>
                      <input
                        className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                        type='number'
                        name='phoneNumber'
                        placeholder='Phone no.'
                        value={formData.phoneNumber}
                        onChange={handleChange}
                      />
                      {errors?.phoneNumber && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.phoneNumber}
                        </p>
                      )}
                    </div>
                    <div div className='d-flex flex-column w-100'>
                      <input
                        className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                        type='email'
                        name='email'
                        placeholder='Email'
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {errors?.email && (
                        <p className='text-danger fs_2xsm mt-1'>
                          {errors.email}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100'>
                    <textarea
                      className='fs_2xsm ff_heebo clr_dark_grey_4 text-area-input w-100 mt-3 ps-3 pt-3'
                      placeholder='Order notes ( optional )'
                      name='notes'
                      value={formData.notes}
                      onChange={handleChange}
                    />
                    {errors?.notes && (
                      <p className='text-danger fs_2xsm mt-1'>{errors.notes}</p>
                    )}
                  </div>
                  <div style={{ width: '150px' }} className='ms-auto'>
                    <button
                      onClick={handleSaveAddress}
                      style={{ height: '40px' }}
                      className='common-darkgreen-button text-white ff_inter fs_sm fw-medium w-100 rounded-2 mt-3'
                    >
                      Save Address
                    </button>
                  </div>
                </div>
              ) : (
                <div className='d-flex flex-column gap-3 address-part-height'>
                  {userAddress?.map((value, index) => (
                    <div
                      className='bg-white p-3 rounded-2 bg-white-border cursor-pointer'
                      key={index}
                      onClick={() => handleAddressSelection(index, value._id)}
                    >
                      <div className='d-flex gap-2'>
                        <div>
                          <input
                            className='input-radio mt-1'
                            type='radio'
                            name='address'
                            checked={selectedAddressIndex === index}
                            onChange={() => setSelectedAddressIndex(index)}
                          />
                        </div>
                        <div>
                          <p className='text-capitalize ff_heebo fw-semibold mb-0'>
                            {value?.firstName + ' ' + value?.lastName}
                          </p>
                          <div className='mt-2'>
                            <p className='ff_heebo text-capitalize mb-0'>
                              {value?.streetAddress}
                            </p>
                            <p className='ff_heebo text-capitalize'>
                              {value?.city +
                                ', ' +
                                value?.state +
                                ' - ' +
                                value?.pincode}
                            </p>
                          </div>
                          <p className='ff_heebo text-capitalize'>
                            Mobile:{' '}
                            <span className='fw-semibold'>
                              {value?.phoneNumber}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {userAddress && userAddress?.length === 0 ? null : (
                <div
                  style={{ width: '150px' }}
                  className='text-end ms-auto mt-3'
                >
                  <button
                    style={{ height: '40px', paddingBottom: '3px' }}
                    onClick={() => setAddNewAddress('d-block')}
                    className={`common-darkgreen-button text-white ff_inter fs_sm fw-medium w-100 rounded-2 ${
                      addNewAddress === 'd-block' ? 'd-none' : 'd-block'
                    }`}
                  >
                    Add Address
                  </button>
                </div>
              )}

              <div
                className={`form-border p-4 rounded-2 mt-3 ${addNewAddress}`}
              >
                {/* Additional form for adding new address */}
                <div className='d-flex align-items-center justify-content-between gap-3'>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                      type='text'
                      name='firstName'
                      placeholder='First Name'
                      value={formData.firstName}
                      onChange={e => handleChange(e)}
                    />
                    {errors?.firstName && (
                      <p className='text-danger fs_2xsm mt-1'>
                        {errors.firstName}
                      </p>
                    )}
                  </div>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                      type='text'
                      name='lastName'
                      placeholder='Last Name'
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                    {errors?.lastName && (
                      <p className='text-danger fs_2xsm mt-1'>
                        {errors.lastName}
                      </p>
                    )}
                  </div>
                </div>
                <div className='d-flex flex-column w-100'>
                  <input
                    className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                    type='text'
                    name='companyName'
                    placeholder='Company name ( optional )'
                    value={formData.companyName}
                    onChange={handleChange}
                  />
                  {errors?.companyName && (
                    <p className='text-danger fs_2xsm mt-1'>
                      {errors.companyName}
                    </p>
                  )}
                </div>
                <div className='d-flex align-items-center justify-content-between gap-3'>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-75 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                      type='text'
                      name='streetAddress'
                      placeholder='Street address'
                      value={formData.streetAddress}
                      onChange={handleChange}
                    />
                    {errors?.streetAddress && (
                      <p className='text-danger fs_2xsm mt-1'>
                        {errors.streetAddress}
                      </p>
                    )}
                  </div>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-25 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                      type='text'
                      name='state'
                      placeholder='State'
                      value={formData.state}
                      onChange={handleChange}
                    />
                    {errors?.state && (
                      <p className='text-danger fs_2xsm mt-1'>{errors.state}</p>
                    )}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-between gap-3'>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                      type='text'
                      name='city'
                      placeholder='Town/City'
                      value={formData.city}
                      onChange={handleChange}
                    />
                    {errors?.city && (
                      <p className='text-danger fs_2xsm mt-1'>{errors.city}</p>
                    )}
                  </div>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3 mt-3'
                      type='text'
                      name='pincode'
                      placeholder='Pin Code'
                      value={formData.pincode}
                      onChange={handleChange}
                    />

                    {errors?.pincode && (
                      <p className='text-danger fs_2xsm mt-1'>
                        {errors.pincode}
                      </p>
                    )}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-between gap-3 mt-3'>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                      type='tel'
                      name='phoneNumber'
                      placeholder='Phone no.'
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      maxLength={10}
                      pattern='[0-9]{10}'
                      onInput={e => {
                        e.target.value = e.target.value
                          .replace(/[^0-9]/g, '')
                          .slice(0, 10)
                      }}
                      required
                    />
                    {errors?.phoneNumber && (
                      <p className='text-danger fs_2xsm mt-1'>
                        {errors.phoneNumber}
                      </p>
                    )}
                  </div>
                  <div className='d-flex flex-column w-100'>
                    <input
                      className='w-100 billing-inputs fs_2xsm clr_dark_grey_4 ps-3'
                      type='email'
                      name='email'
                      placeholder='Email'
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors?.email && (
                      <p className='text-danger fs_2xsm mt-1'>{errors.email}</p>
                    )}
                  </div>
                </div>

                <div className='d-flex flex-column w-100'>
                  <textarea
                    className='fs_2xsm ff_heebo clr_dark_grey_4 text-area-input w-100 mt-3 ps-3 pt-3'
                    placeholder='Order notes ( optional )'
                    name='notes'
                    value={formData.notes}
                    onChange={handleChange}
                  />
                  {errors?.notes && (
                    <p className='text-danger fs_2xsm mt-1'>{errors.notes}</p>
                  )}
                </div>
                <div style={{ width: '150px' }} className='ms-auto'>
                  <button
                    onClick={handleSaveAddress}
                    style={{ height: '40px' }}
                    className='common-darkgreen-button text-white ff_inter fs_sm fw-medium w-100 rounded-2 mt-3'
                  >
                    Save Address
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default BillingDetails
